import React from 'react'

function SectionTagline({children}) {
  return (
    <span className="text-zinc-500 text-[15px] leading-[22px] font-medium">{children}</span>
  )
}

export default SectionTagline